/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BvRolleBerechtigung { 
    funktionsbereich_id: string;
    rolle_id: string;
    darf_funkprotokoll?: boolean;
    darf_funkprotokoll_loeschen?: boolean;
    darf_funkprotokoll_lesen?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

